var render = function render(){var _vm=this,_c=_vm._self._c;return _c('u-popover',{attrs:{"offset":[4, 4]}},[_c('div',{staticClass:"window-context-menu"},[_c('ul',[_c('li',[_c('a',{staticClass:"menuItem"},[_vm._v("Ocultar comentários do sistema")])]),_c('li',[_c('a',{staticClass:"menuItem"},[_c('u-icon',{staticClass:"m-r-xs",attrs:{"name":"info-circle","type":"fa","color":""}}),_vm._v(" Ajuda ")],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }